// Generated by scripts/build-ui-icons.mjs.
export { ArrowSquareOut as default } from "../ui/glyphs-1";
